import React from 'react'
import ScrollingCards from '../../../ui/ScrollingCards';
import useFetchData from '../../../hooks/useFetchData';
import { getActivitiesInProject } from '../../../apis/impact-report/report';
import Loader from '../../../ui/Loader';
import EmptyArray from '../../../ui/EmptyArray';

import ActivityUnderProject from './ActivityUnderProject';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';


const ActivitiesUnderProject = ({ projectId, projectTitle, imageGenerationTimestamp }) => {
  const { loading, response, error } = useFetchData(getActivitiesInProject, [projectId, imageGenerationTimestamp], [projectId, imageGenerationTimestamp]);
  const navigate = useNavigate()
  console.log(response, projectTitle, "activities in projects")
  return (
    <div className='mt-12'>
      <div className='flex items-center justify-between'>
        <h2 className="text-xl font-bold text-textSecondary mb-2"> {`Activities under project (${response?.length ? response?.length : 0
          })`} </h2>
        {(loading ? false : response?.length > 0 ? true : false) && <p onClick={() => {
          navigate(`/profile/gallery/projectic/${projectId}/activities/?projectTitle=${projectTitle}`)
        }
        } className='font-medium underline-offset-2 underline text-textSecondary cursor-pointer'>
          View all
        </p>}

      </div>



      <ScrollingCards isButtonShow={loading ? false : response?.length > 0 ? true : false} >


        {loading ? (
          <div className="h-52 w-full flex items-center justify-center">
            <Loader color={'fill-[#326F58]'} />
          </div>
        ) : response?.length > 0 ? (
          response?.map((activity, i) => {
            return (
              <ActivityUnderProject key={activity?._id + Math.random()} activity={activity} />
            );
          })
        ) : (
          <div className='flex w-full h-[15.1875rem] rounded-md bg-grayBgNormal items-center justify-center'>
            <p>
              No Data Available
            </p>
          </div>
        )}

      </ScrollingCards>
    </div>
  )
}

export default ActivitiesUnderProject;